import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

/* eslint-disable */
import MomentUtils from '@date-io/moment';
import { MuiPickersUtilsProvider } from 'material-ui-pickers';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';

import 'typeface-roboto'
import './index.css';
import './test.css';
import 'utils/faIcons';

import App from './components/App';

import store from 'store';
import registerServiceWorker, { unregister } from './registerServiceWorker';

const theme = createMuiTheme({
  zIndex: {
    overlay: 1250,
    actionsBar: 1350,
    menu: 1450,
    tooltipAction: 1550
  }
});

//console.log("THEME:", theme);

ReactDOM.render(
  <Provider store={store}>
    <MuiPickersUtilsProvider utils={MomentUtils}>
      <MuiThemeProvider theme={theme}>
        <App />
      </MuiThemeProvider>
    </MuiPickersUtilsProvider>
  </Provider>,
  document.getElementById('root')
);

registerServiceWorker();
//unregister();



// WEBPACK FOOTER //
// ./src/index.js